import tw, { styled } from 'twin.macro';

export const StyledContent = tw.section`p-4 sm:p-6 max-w-[1200px] mx-auto z-10 flex items-center`;

export const StyledContainer = styled.div`
	${tw`flex flex-1`}
`;
